<template>
  <div class="product__details details">
    <div v-if="!isPreorder" class="details__wrap details__wrap--with-border">
      <header class="details__header" @click="toggleListHidden('delivery')">
        <h2 class="details__title">
          {{ $t('delivery.title') + ' ' + 'в' }}
          <span class="details__select-city" @click.stop="$modal.show('geo-modal')">{{ cityName }}</span>
        </h2>
        <button class="details__toggle-btn" :class="{ 'details__toggle-btn--rotate': !hiddenLists.delivery }"></button>
      </header>
      <div v-if="!isArchive && !isOnlyOnSite && price && !isPreorder" class="details__check-availability check-availability">
        <div class="check-availability__info">
          <div class="check-availability__text title-text">
            {{ $t('delivery.get_from_store') }}
          </div>
          <div class="check-availability__text">
            <span class="check-availability__text--time">{{ computedPickupTime }}</span>
            <span class="check-availability__text--success">{{ $t('delivery.free.price') }}</span>
          </div>
        </div>
        <Button @click.native="checkAvailability" class="check-availability__btn" type="plain">
          {{ $t('check_availability') }}
        </Button>
      </div>
      <ul v-if="inStock && !([8999, 9000, 9001].includes(parseInt(productId)) && new Date().getTime() <= 1710971999000)" class="details__list details__list--delivery" :class="{ 'details__list--hidden': hiddenLists.delivery }">
        <template v-if="inStock">
          <!--          <li class="details__list-item details__list-item&#45;&#45;dm" v-if="!isOnlyOnSite">-->
          <!--            <div class="details__delivery-wrap">-->
          <!--              <div class="details__delivery-info">-->
          <!--                <span class="details-info__text">{{ $t('delivery.pickup') }}</span>-->
          <!--              </div>-->
          <!--              <span class="delivery-info__price delivery-info__price&#45;&#45;free">{{-->
          <!--                  $t('delivery.free.price')-->
          <!--                }}</span>-->
          <!--            </div>-->
          <!--          </li>-->
          <!-- li class="details__list-item details__list-item--quick" v-if="!isOnlyOnSite">
            <div class="details__delivery-wrap">
              {{ titleForExpressDelivery }}
              <span class="delivery-info__price">
                {{ $t('delivery.company.quick.courier.price') }}
              </span>
            </div>
          </li -->
          <li class="details__list-item details__list-item--dm" v-if="!isOnlyOnSite && availableInCityStores">
            <div class="details__delivery-wrap">
              {{ $t('delivery.company.courier') }}
              <span
                class="delivery-info__price"
                :class="{ 'delivery-info__price--free': isFreeDeliveryCourierDm }"
              >
                {{ isFreeDeliveryCourierDm ? $t('delivery.free.price') : $t('delivery.company.courier.price') }}
              </span>
            </div>
          </li>
          <li class="details__list-item details__list-item--np">
            <div class="details__delivery-wrap">
              {{ $t('delivery.np') }}
              <span class="delivery-info__price"
                    :class="{ 'delivery-info__price--free': isFreeDeliveryNp }">
                {{ isFreeDeliveryNp ? $t('delivery.free.price') : $t('post_office.np.cost') }}
              </span>
            </div>
          </li>
          <li class="details__list-item details__list-item--np">
            <div class="details__delivery-wrap">
              {{ $t('delivery.np.courier') }}
              <span class="delivery-info__price" :class="{ 'delivery-info__price--free': isNpCourierPriceOverLimit }">{{
                isNpCourierPriceOverLimit ? $t('np.tarifs') : $t('courier.np.cost')
              }}</span>
            </div>
          </li>
          <li class="details__list-item details__list-item--np" v-if="isOnThePostomatList">
            <div class="details__delivery-wrap">
              {{ $t('delivery.np.box') }}
              <span class="delivery-info__price" :class="{ 'delivery-info__price--free': isFreePostomatNp }">
                {{ isFreePostomatNp ? $t('delivery.free.price') : $t('postomat.np.cost') }}</span>
            </div>
          </li>
          <li v-if="maxSideLength" class="details__list-item details__list-item--up">
            <div class="details__delivery-wrap">
              {{ $t('delivery.up') }}
              <span class="delivery-info__price"
                    :class="{ 'delivery-info__price--free': isFreeDeliveryUp }">
                {{ isFreeDeliveryUp ? $t('delivery.free.price') : $t('delivery.up.price') }}
              </span>
            </div>
          </li>
        </template>
      </ul>
      <InfoButton
        class="details__info-btn"
        tooltip-horizontal-align="right"
        tooltip-is-arrow
        tooltip-is-arrow-right
        :tooltip-text="$t('tooltip.delivery')"
      />
    </div>
    <div class="details__wrap">
      <header class="details__header" @click="toggleListHidden('services')">
        <div class="details__header-wrap">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.9258 20.6312L13.3381 21.5422L12.9258 20.6312ZM11.074 20.6312L10.6616 21.5422L11.074 20.6312ZM4.21799 4.09204L5.10899 4.54603L4.21799 4.09204ZM5.0918 3.21799L5.54579 4.10899L5.0918 3.21799ZM12.3389 20.8262L12.1697 19.8406L12.3389 20.8262ZM11.6619 20.8262L11.8311 19.8406L11.6619 20.8262ZM19.7822 4.09204L18.8912 4.54603V4.54603L19.7822 4.09204ZM18.9078 3.21799L19.3618 2.32698V2.32698L18.9078 3.21799ZM19 6.19995V10.1648H21V6.19995H19ZM19 10.1648C19 16.1204 14.5186 18.8125 12.5134 19.7201L13.3381 21.5422C15.5453 20.5431 21 17.3457 21 10.1648H19ZM11.4863 19.7201C9.48121 18.8125 5 16.1204 5 10.1648H3C3 17.3457 8.45439 20.5431 10.6616 21.5422L11.4863 19.7201ZM5 10.1648V6.19995H3V10.1648H5ZM7.2002 4H16.8002V2H7.2002V4ZM5 6.19995C5 5.6234 5.00078 5.25114 5.02393 4.96783C5.04612 4.6962 5.0838 4.59549 5.10899 4.54603L3.32698 3.63805C3.13419 4.01642 3.06287 4.40961 3.03057 4.80495C2.99922 5.18861 3 5.6564 3 6.19995H5ZM7.2002 2C6.65663 2 6.18874 1.99922 5.80498 2.03057C5.40962 2.06286 5.01624 2.13416 4.63781 2.32698L5.54579 4.10899C5.59517 4.08383 5.69595 4.04613 5.9678 4.02393C6.25126 4.00078 6.62365 4 7.2002 4V2ZM5.10899 4.54603C5.205 4.35761 5.35788 4.20474 5.54579 4.10899L4.63781 2.32698C4.07306 2.61473 3.61447 3.07382 3.32698 3.63805L5.10899 4.54603ZM12.5134 19.7201C12.3914 19.7753 12.3497 19.7936 12.3113 19.8071C12.2867 19.8157 12.2517 19.8266 12.1697 19.8406L12.5081 21.8118C12.8903 21.7462 13.0955 21.652 13.3381 21.5422L12.5134 19.7201ZM10.6616 21.5422C10.9057 21.6527 11.1113 21.7463 11.4927 21.8118L11.8311 19.8406C11.7488 19.8265 11.7132 19.8156 11.6881 19.8068C11.6497 19.7933 11.6074 19.7749 11.4863 19.7201L10.6616 21.5422ZM12.1697 19.8406C12.182 19.8385 12.1712 19.8409 12.1299 19.8433C12.0936 19.8454 12.0485 19.8467 12.0004 19.8467C11.9522 19.8467 11.9072 19.8454 11.8709 19.8433C11.8295 19.8409 11.8187 19.8385 11.8311 19.8406L11.4927 21.8118C11.6579 21.8402 11.8554 21.8467 12.0004 21.8467C12.1453 21.8467 12.3429 21.8402 12.5081 21.8118L12.1697 19.8406ZM21 6.19995C21 5.6565 21.0008 5.1887 20.9695 4.80511C20.9373 4.40983 20.8661 4.01653 20.6732 3.63805L18.8912 4.54603C18.9164 4.59537 18.954 4.69598 18.9762 4.96767C18.9993 5.25105 19 5.6233 19 6.19995H21ZM16.8002 4C17.3768 4 17.7489 4.00078 18.0321 4.02393C18.3036 4.04611 18.4043 4.08377 18.4538 4.10899L19.3618 2.32698C18.9835 2.13421 18.5904 2.06288 18.1951 2.03057C17.8115 1.99922 17.3437 2 16.8002 2V4ZM20.6732 3.63805C20.3854 3.07315 19.9259 2.61439 19.3618 2.32698L18.4538 4.10899C18.6424 4.20508 18.7956 4.35828 18.8912 4.54603L20.6732 3.63805Z" fill="#909090"/>
            <path d="M15 9L11 13L9 11" stroke="#909090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div class="details__title-wrap">
            <template v-if="warranty.length === 1">
              <div class="details__title">
                <div v-for="(product, i) in warranty" :key="i">
                <span class="details__list-item-text">{{
                    warranty.length > 1 ? product.name[language] + ':' + ' ' : ''
                  }}</span>
                  {{ product.warranty }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="details__title">
                Гарантія
              </div>
              <div class="details__subtitle secondary">
                <div v-for="(product, i) in warranty" :key="i">
                <span class="details__list-item-text">{{
                    warranty.length > 1 ? product.name[language] + ':' + ' ' : ''
                  }}</span>
                  {{ product.warranty }}
                </div>
              </div>
            </template>
            <div class="details__subtitle" v-if="$t('warranty.14.days')">{{ $t('warranty.14.days') }}</div>
            <div class="details__subtitle" v-if="$t('refund.60.days')">{{ $t('refund.60.days') }}</div>
          </div>
        </div>
        <button class="details__toggle-btn" :class="{ 'details__toggle-btn--rotate': !hiddenLists.services }"></button>
      </header>
      <InfoButton
        class="details__info-btn"
        tooltip-horizontal-align="right"
        tooltip-is-arrow
        tooltip-is-arrow-right
        :tooltip-text="$t('tooltip.service')"
      />
    </div>
    <div class="details__wrap">
      <header class="details__header" @click="toggleListHidden('payment')">
        <div class="details__header-wrap">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.21799 6.09204L4.10899 6.54603L3.21799 6.09204ZM4.0918 5.21799L4.54579 6.10899L4.0918 5.21799ZM4.0918 18.782L4.54579 17.891H4.54579L4.0918 18.782ZM3.21799 17.908L2.32698 18.362H2.32698L3.21799 17.908ZM20.7822 17.908L19.8912 17.454L20.7822 17.908ZM19.9078 18.782L19.4538 17.891L19.9078 18.782ZM20.7822 6.09204L19.8912 6.54603V6.54603L20.7822 6.09204ZM19.9078 5.21799L20.3618 4.32698V4.32698L19.9078 5.21799ZM7 14C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16V14ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM3 10C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12V10ZM21 12C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10V12ZM3 8C2.44772 8 2 8.44772 2 9C2 9.55228 2.44772 10 3 10V8ZM21 10C21.5523 10 22 9.55228 22 9C22 8.44772 21.5523 8 21 8V10ZM20 8.19995V15.8H22V8.19995H20ZM17.8002 18H6.2002V20H17.8002V18ZM4 15.8V8.19995H2V15.8H4ZM6.2002 6H17.8002V4H6.2002V6ZM4 8.19995C4 7.6234 4.00078 7.25114 4.02393 6.96783C4.04612 6.6962 4.0838 6.59549 4.10899 6.54603L2.32698 5.63805C2.13419 6.01642 2.06287 6.40961 2.03057 6.80495C1.99922 7.18861 2 7.6564 2 8.19995H4ZM6.2002 4C5.65663 4 5.18874 3.99922 4.80498 4.03057C4.40962 4.06286 4.01624 4.13416 3.63781 4.32698L4.54579 6.10899C4.59517 6.08383 4.69595 6.04613 4.9678 6.02393C5.25126 6.00078 5.62365 6 6.2002 6V4ZM4.10899 6.54603C4.205 6.35761 4.35788 6.20474 4.54579 6.10899L3.63781 4.32698C3.07306 4.61473 2.61447 5.07382 2.32698 5.63805L4.10899 6.54603ZM6.2002 18C5.62367 18 5.25127 17.9992 4.96782 17.9761C4.69598 17.9538 4.59519 17.9161 4.54579 17.891L3.63781 19.673C4.01623 19.8658 4.40959 19.9371 4.80496 19.9694C5.18873 20.0008 5.65662 20 6.2002 20V18ZM2 15.8C2 16.3435 1.99922 16.8113 2.03057 17.195C2.06287 17.5904 2.13418 17.9836 2.32698 18.362L4.10899 17.454C4.08381 17.4046 4.04613 17.3039 4.02393 17.0322C4.00078 16.7488 4 16.3765 4 15.8H2ZM4.54579 17.891C4.35778 17.7952 4.20494 17.6424 4.10899 17.454L2.32698 18.362C2.61452 18.9264 3.07317 19.3853 3.63781 19.673L4.54579 17.891ZM20 15.8C20 16.3766 19.9993 16.7489 19.9762 17.0323C19.954 17.3041 19.9163 17.4047 19.8912 17.454L21.6732 18.362C21.8661 17.9835 21.9373 17.5902 21.9696 17.1949C22.0008 16.8112 22 16.3434 22 15.8H20ZM17.8002 20C18.3438 20 18.8115 20.0008 19.1951 19.9694C19.5904 19.9371 19.9835 19.8657 20.3618 19.673L19.4538 17.891C19.4043 17.9162 19.3036 17.9539 19.0321 17.9761C18.7489 17.9992 18.3767 18 17.8002 18V20ZM19.8912 17.454C19.7956 17.6417 19.6425 17.7948 19.4538 17.891L20.3618 19.673C20.9257 19.3856 21.3854 18.927 21.6732 18.362L19.8912 17.454ZM22 8.19995C22 7.6565 22.0008 7.1887 21.9695 6.80511C21.9373 6.40983 21.8661 6.01653 21.6732 5.63805L19.8912 6.54603C19.9164 6.59537 19.954 6.69598 19.9762 6.96767C19.9993 7.25105 20 7.6233 20 8.19995H22ZM17.8002 6C18.3768 6 18.7489 6.00078 19.0321 6.02393C19.3036 6.04611 19.4043 6.08377 19.4538 6.10899L20.3618 4.32698C19.9835 4.13421 19.5904 4.06288 19.1951 4.03057C18.8115 3.99922 18.3437 4 17.8002 4V6ZM21.6732 5.63805C21.3854 5.07316 20.9259 4.61439 20.3618 4.32698L19.4538 6.10899C19.6424 6.20507 19.7956 6.35828 19.8912 6.54603L21.6732 5.63805ZM7 16H11V14H7V16ZM3 12H21V10H3V12ZM3 10H21V8H3V10Z" fill="#909090"/>
          </svg>
          <div class="details__title-wrap">
            <div class="details__title">
              {{ $t('checkout_payment') }}
            </div>
            <div class="details__subtitle">{{ $t('product-page__payment-types') }}</div>
          </div>
        </div>
        <button class="details__toggle-btn" :class="{ 'details__toggle-btn--rotate': !hiddenLists.payment }"></button>
      </header>
      <InfoButton
        class="details__info-btn"
        tooltip-horizontal-align="right"
        tooltip-is-arrow
        tooltip-is-arrow-right
        :tooltip-text="$t('tooltip.payment')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import dateTimeHelper from '@/helpers/dateTimeHelpers'
import { isTouch } from '../../../mixins/isTouchDevice'
import { formattedDeliveryInfo } from '../../../mixins'
import InfoButton from '../../helpers/InfoButton'
import Button from '@/components/inputs/Button'
import {
  COURIER_PRICE_LIMIT,
  NOVA_POSHTA_COURIER_PRICE_LIMIT,
  NOVA_POSHTA_PRICE_LIMIT,
  UKR_POSHTA_PRICE_LIMIT,
  NOVA_POSHTA_POSTOMAT_PRICE_LIMIT
} from '@/constants'

export default {
  name: 'ProductDetails',
  mixins: [isTouch, formattedDeliveryInfo],
  data () {
    return {
      isLoadingAvailability: false,
      hiddenLists: {
        delivery: false,
        services: false,
        payment: true
      }
    }
  },
  components: {
    InfoButton,
    Button
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isUkLanguage']),
    ...mapState({
      isOnlyOnSite: state => state.productInfo.productInfo.isOnlyOnSite,
      inStock: state => state.productInfo.productInfo.inStock,
      isArchive: state => state.productInfo.productInfo.isArchive,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      availableInCityStores: state => state.productInfo.productInfo.availableInCityStores,
      price: state => state.productInfo.productInfo.price,
      productId: state => state.productInfo.productInfo.productId,
      code: state => state.productInfo.productInfo.code,
      warranty: state => state.productInfo.warranty,
      maxSideLength: state => state.productInfo.productInfo.maxSideLength,
      language: state => state.translation.language,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      managerStoreUid: state => state.checkout.managerStoreUid,
      shopMaxOpeningHoursInUserCity: state => state.productInfo.productInfo.shopMaxOpeningHoursInUserCity
    }),
    computedPickupTime () {
      const currentTime = new Date()
      const currentHours = currentTime.getHours()
      const currentMinutes = currentTime.getMinutes()
      const parts = this.shopMaxOpeningHoursInUserCity.split(':')
      const hoursFromShops = parts[0]
      const minutesFromShops = parts[1]
      if (currentHours < (hoursFromShops || 19) || (currentHours === (hoursFromShops || 19) && currentMinutes <= (minutesFromShops || 30))) {
        return this.$t('pickup_today')
      }
      return this.$t('pickup_tomorrow')
    },
    isNpCourierPriceOverLimit () {
      return +this.price > NOVA_POSHTA_COURIER_PRICE_LIMIT
    },
    isFreeDeliveryCourierDm () {
      return +this.price > COURIER_PRICE_LIMIT
    },
    isFreeDeliveryUp () {
      return +this.price > UKR_POSHTA_PRICE_LIMIT
    },
    isFreeDeliveryNp () {
      return +this.price > NOVA_POSHTA_PRICE_LIMIT
    },
    isFreePostomatNp () {
      return +this.price > NOVA_POSHTA_POSTOMAT_PRICE_LIMIT
    },
    isOnThePostomatList () {
      const codes = [
        59646000,
        59527000,
        81123008,
        41615000,
        59609000,
        58974000,
        58728000,
        59369000,
        58293000,
        58294000,
        22794000,
        22795000,
        59274000,
        22721000,
        22837000,
        79839006,
        16953000,
        19838001,
        80591000,
        82132002,
        49049000,
        80755001,
        79839004,
        81009000,
        72597000,
        79812000,
        68720000,
        82175001,
        19628002,
        15451002,
        82009002,
        82009001,
        81704002,
        81375007,
        76826001,
        67568006,
        20477000,
        8117000,
        19789001,
        49293000,
        49893000,
        76840000,
        49294001,
        16847000,
        49295001,
        81701000,
        19626002,
        58796000,
        49048000,
        52783000,
        82054006,
        83362000,
        58015002,
        21216005,
        16042002,
        97951001,
        97440000,
        97437000,
        82046000,
        80496003,
        79640000,
        81282005,
        59606004,
        82340009,
        80496002,
        19625006,
        16853000,
        59961000,
        58661000,
        58232000,
        58233000,
        58234000,
        41741000,
        21672000,
        17703001,
        16956001,
        16860000,
        17649004,
        17649001,
        17649002,
        17649003,
        17650004,
        17650001,
        17650002,
        17650003,
        16253003,
        16253002,
        16253001,
        16252003,
        16252002,
        16252001,
        16251003,
        16251002,
        16251001,
        16250003,
        16250002,
        16250001,
        98279001,
        82340011,
        82340010,
        19804001,
        49453011,
        49453010,
        49741006,
        72983000,
        81523000,
        80496001,
        79818000,
        76643000,
        41499000,
        72351000,
        76641000,
        83412000,
        20886002,
        97442000,
        97236000,
        82398000,
        52419000,
        82041000,
        41454000,
        82040000,
        81703000,
        81578000,
        67622000,
        52112000,
        49287000,
        97829000,
        98936000,
        98704000,
        97621000,
        82194000,
        49296000,
        19960002,
        49978000,
        82343000,
        81702000,
        80636000,
        80635000,
        58010002,
        21407000,
        21408000,
        83337001,
        16859000,
        97383000,
        16383000,
        8111000,
        8110000,
        16587004,
        16587003,
        16587002,
        16587001,
        16590004,
        16590003,
        16590002,
        16590001,
        16589004,
        16589003,
        16589002,
        16589001,
        21855000,
        21854000,
        16588004,
        16588003,
        16588002,
        16588001,
        49755000,
        82716000,
        82715000,
        49729000,
        49525000,
        49523000,
        82009004,
        49810001,
        49810003,
        49810005,
        19899000,
        81430000,
        67568018,
        52217000,
        22634000,
        22635000,
        41448000,
        82219000,
        49753009,
        97620000,
        41798000,
        80625040,
        82942001,
        82054017,
        49533000,
        19588000,
        19419000,
        81347000,
        80989000,
        81577000,
        72867000,
        59606003,
        49453007,
        58292000,
        58295000,
        22791022,
        80589000,
        97323000,
        20853005,
        22894000,
        21789001,
        20863001,
        82943002,
        17651001,
        97421000,
        8112000,
        82998001,
        82047000,
        82943005,
        49232001,
        49886000,
        49980000,
        49047000,
        19032000,
        19031000,
        79644004,
        67618000,
        68551000,
        82946000,
        49453008,
        20468000,
        97322000,
        52782000,
        19625005,
        59327002,
        59327001,
        79839005,
        8430000,
        8409000,
        81993000,
        19201005,
        49844000,
        81994000,
        41502000,
        80757001,
        79839003,
        81375008,
        79817000,
        80985000,
        79644008,
        67568013,
        68222000,
        97076000,
        16138000,
        58015001,
        81415000,
        58299000,
        41613000,
        41473000,
        67568037,
        16054000,
        22791021,
        17707000,
        97418000,
        79995000,
        81314000,
        81003000,
        67585001,
        72626000,
        19744000,
        49820000,
        59601000,
        98761000,
        19467001,
        62054000,
        82054035,
        82054005,
        82054012,
        81916000,
        16750003,
        17706000,
        8410000,
        8411000,
        61546043,
        61546032,
        98834007,
        98834006,
        98834005,
        98834004,
        22541000,
        98834003,
        98834002,
        98834001,
        82204000,
        22672000,
        82054022,
        21371000,
        21224000,
        21628000,
        19960001,
        19925003,
        80592000,
        19803001,
        49453009,
        81568000,
        81992000,
        81972000,
        81915000,
        16750002,
        80625012,
        81066000,
        81010000,
        81029000,
        81002000,
        67568021,
        70757000,
        22557000,
        22791019,
        17645000,
        15468000,
        59376000,
        97419000,
        49297004,
        49297008,
        41811000,
        22791020,
        20604000,
        20605000,
        16852000,
        16858000,
        16851000,
        16854000,
        16850000,
        16248004,
        16248003,
        16248002,
        16248001,
        16247004,
        16247003,
        16247002,
        22539000,
        22540000,
        16247001,
        16246004,
        16246003,
        16246002,
        16246001,
        8118000,
        8666000,
        82845000,
        82004000,
        82340007,
        49524000,
        49522000,
        49521000,
        49520000,
        49527000,
        49526000,
        19925002,
        81160000,
        80624000,
        81065000,
        79813000,
        81282003,
        81282004,
        67394000,
        67396000,
        49726031,
        49726019,
        19926001,
        97133000,
        41738000,
        21216004,
        49806000,
        17482000,
        81659000,
        83413000,
        13110002,
        20886001,
        20519000,
        21216003,
        21216002,
        20608000,
        15345001,
        15410000,
        20715001,
        20715003,
        20715004,
        20715002,
        20715005,
        20715006,
        98938000,
        66099000,
        82203000,
        82340008,
        49618000,
        49138000,
        19589000,
        80759000,
        80751001,
        79999000,
        81414000,
        81794000,
        81375003,
        81008000,
        81007000,
        81282002,
        81282001,
        79644003,
        67568012,
        58973000,
        20863004,
        20863002,
        19933002,
        16874000,
        16873000,
        20742002,
        49821000,
        49375003,
        49376003,
        81917000,
        67569005,
        67569004,
        67568016,
        81918000,
        16237000,
        19625003,
        59388000,
        13111001,
        41622001,
        17766000,
        41563001,
        20606001,
        20611000,
        17844000,
        20609000,
        20610000,
        49726027,
        49726018,
        53926000,
        82712000,
        82163000,
        19628001,
        80760000,
        80752002,
        80751002,
        81346000,
        80625011,
        80588000,
        67568017,
        68216000,
        72593000,
        17545000,
        68221000,
        62021000,
        81914000,
        82531000,
        49884000,
        19201004,
        79839002,
        67728000,
        58010001,
        19213000,
        49365000,
        80963004,
        67568032,
        67568036,
        19677000,
        13110001,
        82943001,
        15370000,
        81204006,
        66097000,
        66100000,
        72985000,
        81386002,
        49977000,
        80598000,
        17554000,
        17555000,
        17557000,
        81990000,
        19413000,
        19416000,
        81375006,
        68025000,
        81553000,
        17765000,
        67835003,
        80963003,
        76838002,
        67574000,
        70693005,
        70693004,
        70127039,
        19932001,
        16049000,
        19210000,
        98891000,
        49137000,
        97163006,
        19676000,
        8095000,
        97163008,
        97163004,
        97163001,
        19212000,
        16848000,
        19466003,
        19211000,
        81991000,
        81403000,
        81191004,
        7638003,
        7638002,
        97163009,
        97163007,
        97163005,
        97163003,
        97163002,
        67835009,
        67835008,
        67835007,
        19466002,
        19626001,
        21924000,
        19466001,
        82054030,
        82054016,
        82054034,
        82054011,
        82054004,
        80963007,
        16958000,
        22793000,
        16750004,
        16750001,
        67835011,
        67835010,
        8100000,
        97001000,
        82999000,
        82054021,
        82105000,
        49836000,
        49453006,
        81989000,
        80746001,
        80752001,
        80750002,
        80750001,
        80747001,
        80746002,
        72984000,
        81913000,
        80634000,
        80610000,
        81318000,
        80962000,
        70972001,
        67715000,
        72496000,
        49297017,
        49815000,
        49812000,
        81345000,
        82049000,
        49297007,
        49297003,
        49294002,
        81385000,
        81567000,
        16957000,
        68220000,
        16482002,
        82054040,
        20607001,
        16856000,
        16271000,
        98280002,
        61546025,
        49275000,
        49996003,
        49996002,
        80749002,
        80749001,
        80748002,
        80748001,
        80747002,
        79839001,
        81997000,
        81191003,
        81191001,
        81317000,
        81582000,
        80963002,
        80963001,
        80132000,
        72833000,
        72798005,
        72798003,
        72798002,
        72798001,
        59373000,
        22694000,
        49726023,
        8466001,
        49996001,
        83433000,
        83432000,
        52431000,
        49726005,
        49726010,
        49726014,
        80963006,
        80963005,
        19030009,
        19029009,
        22791018,
        49883000,
        49816000,
        98700003,
        81912000,
        59606002,
        16955002,
        49453005,
        81960000,
        81961000,
        49979000,
        59384000,
        15464004,
        20853004,
        41742000,
        41735000,
        15344002,
        15349000,
        17705000,
        20853001,
        17767000,
        20784001,
        20784002,
        16433000,
        98042000,
        16452000,
        8223002,
        8223001,
        8114000,
        8106000,
        80625033,
        8458000,
        8459000,
        82777007,
        16310000,
        82777006,
        49990000,
        19782001,
        19930001,
        19931002,
        49604000,
        49885000,
        19927001,
        19925001,
        49741004,
        81959000,
        81958000,
        19754002,
        19754001,
        81962000,
        80754001,
        80756001,
        81925000,
        81924000,
        81191002,
        80604000,
        81001000,
        80992000,
        80611000,
        80933000,
        76827005,
        76827004,
        72933000,
        72798004,
        72526004,
        70693002,
        70693001,
        72059000,
        72594000,
        98700002,
        82777005,
        52397000,
        22480000,
        49726022,
        49726017,
        16043002,
        72538003,
        21290000,
        16960000,
        60319001,
        81653000,
        72538002,
        52479000,
        98700001,
        15464003,
        20734000,
        16043001,
        49933000,
        41450000,
        19625002,
        98692000,
        59374000,
        21405000,
        52114000,
        21768003,
        20854000,
        17704000,
        16381000,
        8449000,
        60319002,
        12313000,
        12314000,
        8392003,
        80625029,
        98687000,
        82406000,
        82713000,
        49126000,
        80757002,
        80498000,
        81996000,
        80618000,
        81585000,
        80999000,
        79821000,
        79815000,
        80986000,
        79652000,
        76827003,
        68215000,
        97328002,
        19459004,
        41622004,
        41500000,
        20741002,
        17845000,
        97180006,
        80625017,
        19201003,
        81030000,
        58972000,
        21406000,
        22431000,
        15464002,
        41972000,
        81522000,
        41492000,
        41563002,
        41563003,
        97328001,
        67568035,
        22791017,
        19445029,
        19445028,
        19445027,
        59830000,
        59327004,
        22922000,
        15411000,
        8120000,
        8446000,
        19209014,
        19209013,
        19209003,
        8392002,
        97622000,
        82014000,
        19784001,
        19786001,
        19787001,
        49375002,
        49376002,
        49819000,
        82121000,
        19461002,
        19714000,
        49420000,
        81632000,
        81971000,
        80558000,
        81011000,
        76681000,
        81138000,
        67835001,
        67835006,
        46930000,
        67835005,
        67835004,
        67569013,
        67569014,
        67569006,
        67569003,
        67568011,
        16048000,
        80001000,
        19772002,
        49247000,
        81911000,
        19690000,
        81869000,
        80204000,
        16769001,
        16875000,
        16314000,
        98730000,
        80625027,
        16498000,
        81654000,
        19462003,
        19462002,
        19461004,
        19461003,
        19462001,
        19461001,
        19668001,
        76827002,
        76827001,
        72536001,
        72535003,
        72534003,
        72534002,
        22792000,
        19464002,
        19781003,
        81864000,
        72537002,
        16218000,
        82054029,
        81236000,
        80890000,
        15464001,
        82054033,
        82200000,
        49371000,
        59645000,
        58318000,
        16221000,
        97328004,
        97328003,
        97326000,
        59607001,
        59327003,
        15332000,
        15350000,
        16449000,
        49726021,
        16269000,
        16270000,
        16268000,
        82054020,
        8454000,
        8064000,
        98040000,
        16244000,
        98609000,
        97330001,
        61546010,
        61546006,
        82054015,
        19464001,
        82992000,
        82991000,
        82054003,
        82340005,
        82340003,
        81386001,
        49453003,
        81660000,
        80757003,
        19570002,
        19570003,
        19570001,
        19570004,
        81776000,
        81344000,
        80995000,
        79351000,
        67661008,
        72526002,
        15571000,
        21956000,
        82054010,
        41778006,
        41425000,
        81866000,
        80602000,
        81023000,
        20726000,
        49998000,
        49297011,
        22429000,
        62056002,
        62056001,
        62056003,
        97132000,
        8087000,
        64004000,
        82002000,
        49999000,
        49297016,
        49297010,
        81235000,
        81988000,
        81022000,
        72800005,
        72800004,
        72800003,
        72800002,
        72800001,
        72526003,
        22981000,
        62056004,
        49297014,
        49297002,
        41449000,
        81865000,
        82019000,
        79996000,
        49297006,
        81384000,
        22791016,
        16686000,
        98703000,
        82340002,
        81868000,
        52113000,
        97542000,
        21413000,
        80625028,
        80625031,
        80625030,
        20505000,
        15330000,
        15328000,
        16051000,
        16727000,
        62056005,
        67832011,
        67832012,
        11885000,
        8225000,
        98717000,
        82013000,
        49758000,
        49757000,
        49756000,
        82037000,
        98698000,
        81970000,
        19735000,
        80753001,
        80747006,
        80748004,
        80747004,
        80746004,
        98690000,
        98691000,
        81923000,
        19228000,
        19029008,
        81521000,
        81995000,
        81987000,
        81141003,
        81141002,
        81141001,
        80994000,
        80633000,
        80981000,
        79656000,
        76080000,
        72525006,
        58319000,
        22582000,
        21768002,
        97357000,
        20742001,
        16488000,
        64006000,
        97324000,
        41778005,
        16367000,
        81955000,
        52972000,
        41739000,
        20894001,
        21216001,
        8466002,
        98041000,
        8224000,
        49726009,
        49726004,
        49726013,
        49832000,
        81957000,
        49931000,
        19030008,
        80493005,
        81956000,
        19468000,
        19772001,
        22791015,
        21689000,
        19687000,
        49372003,
        41472000,
        98613001,
        82340006,
        19781002,
        41629002,
        41633002,
        97330002,
        59598000,
        83428000,
        82376000,
        59600003,
        59600002,
        59600001,
        59597000,
        59596000,
        59474001,
        59474003,
        58231000,
        22508000,
        22509000,
        82054041,
        82054042,
        82054039,
        82054038,
        1151000,
        8098000,
        19571003,
        82998003,
        19459001,
        49565000,
        82307000,
        19783001,
        82777003,
        19459003,
        19682000,
        49335000,
        49474000,
        81381000,
        82045000,
        49900001,
        49741005,
        49741003,
        81862000,
        80752004,
        19030004,
        80494005,
        79664000,
        79875001,
        79653000,
        76661000,
        72533001,
        49726020,
        19460002,
        49982000,
        49726035,
        41778003,
        49726029,
        49726028,
        49305003,
        19570009,
        16482001,
        49726024,
        49077000,
        17695001,
        19688000,
        19460001,
        59474002,
        52115000,
        22855000,
        16425000,
        49726015,
        19781001,
        80605000,
        49930000,
        49078000,
        19041001,
        19029005,
        81517000,
        79871001,
        67584001,
        41850000,
        81858000,
        97328005,
        62058000,
        16309000,
        97005000,
        97328006,
        41535000,
        22688000,
        49726016,
        49726026,
        82048000,
        49373002,
        19625001,
        41432000,
        20741001,
        49882000,
        83700000,
        22691000,
        22513000,
        15329000,
        15346000,
        16741000,
        16044000,
        16046000,
        16045000,
        8105000,
        82018000,
        82017000,
        82714000,
        82844000,
        19780003,
        49305002,
        49306000,
        49129000,
        19036000,
        49076000,
        19034000,
        80493004,
        80492005,
        81974000,
        81986000,
        81985000,
        81413000,
        81758000,
        69585000,
        69668000,
        79662000,
        79654000,
        79647000,
        72829000,
        68205000,
        67438000,
        41451000,
        49367000,
        81383000,
        19201029,
        67568015,
        21438000,
        19689000,
        49373004,
        15345002,
        8672001,
        82405000,
        49726008,
        49726003,
        19959002,
        81382000,
        49927000,
        80494004,
        81984000,
        81795000,
        72827000,
        67569010,
        67568010,
        72799003,
        41633001,
        19743000,
        19669001,
        67568030,
        82601005,
        67568028,
        67568026,
        72349000,
        16015000,
        83370000,
        52433000,
        41988000,
        22494000,
        8467003,
        19209002,
        97191002,
        97180005,
        61546005,
        82601003,
        19458001,
        82601002,
        72332000,
        72331000,
        72330000,
        49332000,
        49333000,
        49334000,
        49375001,
        49929000,
        49740005,
        19030003,
        80493003,
        80493001,
        80490008,
        81983000,
        67832004,
        67832003,
        79554001,
        80730003,
        67569012,
        67569011,
        67569008,
        67569002,
        67569001,
        67570020,
        67570021,
        67570019,
        72526001,
        20890000,
        19209008,
        19445018,
        19445020,
        19445021,
        19445022,
        52432000,
        52430000,
        22791014,
        49726034,
        16047000,
        19456002,
        19456001,
        49818000,
        49813000,
        72531002,
        72531001,
        19445031,
        19209005,
        19445026,
        97883000,
        19445019,
        19445017,
        49726033,
        49726032,
        19209012,
        19209010,
        83409000,
        21227000,
        8176000,
        19570006,
        82404000,
        82601004,
        49130000,
        80494003,
        80493002,
        80492004,
        72799004,
        72525004,
        72525003,
        72525002,
        72525001,
        21843000,
        8672002,
        97180003,
        98693000,
        82502000,
        19459002,
        82054028,
        82054032,
        82054025,
        82054009,
        82054027,
        19788001,
        19959003,
        49881000,
        15464008,
        15464007,
        15464006,
        15464005,
        59599000,
        52398000,
        21175000,
        22663004,
        22663002,
        22663003,
        97443000,
        22661004,
        97441000,
        22661002,
        22661003,
        97436000,
        15347002,
        15347001,
        15413000,
        16959002,
        16959001,
        67832015,
        67832013,
        67832014,
        82054014,
        8460000,
        98702002,
        98702001,
        8247000,
        98701000,
        61546003,
        97190004,
        61485005,
        82501000,
        82500000,
        82499000,
        19780002,
        19780001,
        82054002,
        49603000,
        82368000,
        49372001,
        81386003,
        49453004,
        49453002,
        49740003,
        49740002,
        49740001,
        49741002,
        49741001,
        81655000,
        80495002,
        80495001,
        80492003,
        80492002,
        80491006,
        80490006,
        80490005,
        81973000,
        81982000,
        81375002,
        81204003,
        76682000,
        79644002,
        72799002,
        72799001,
        49616000,
        81953000,
        22791013,
        41671000,
        8673000,
        82798000,
        49740007,
        49740006,
        19669002,
        49726025,
        98694000,
        81952000,
        81204004,
        59383000,
        49297015,
        49740004,
        41622002,
        15333001,
        15331000,
        97191001,
        97180002,
        49297009,
        49297005,
        49543001,
        49372002,
        49376001,
        80499003,
        80499002,
        80499001,
        80494002,
        80491005,
        80490007,
        81351000,
        79871003,
        72799005,
        67635000,
        67634000,
        41446000,
        8453000,
        82586000,
        49297001,
        82601001,
        81399003,
        20894002,
        49297013,
        8467002,
        49373003,
        19570010,
        15333003,
        17697000,
        16483000,
        20391003,
        8113000,
        97190002,
        19570005,
        49726012,
        49726007,
        49726002,
        82711004,
        82711003,
        82711002,
        82711001,
        49600000,
        49373001,
        49366000,
        49928000,
        49452000,
        19652000,
        80747005,
        80748003,
        80746003,
        19029007,
        80497003,
        80494001,
        80492001,
        81793000,
        67832001,
        80129003,
        80129001,
        79644006,
        67570018,
        67570016,
        67570014,
        67570012,
        67570011,
        41319000,
        22791012,
        16371000,
        49925000,
        15372000,
        15371000,
        16280002,
        98686000,
        82050000,
        16280001,
        81342000,
        52148000,
        41426000,
        16772000,
        98281002,
        98281001,
        49880000,
        67832007,
        67832008,
        19030007,
        80497002,
        80490004,
        67832002,
        62057000,
        81343000,
        97190003,
        82707000,
        81204005,
        98611009,
        98613005,
        98613004,
        98613002,
        98611010,
        83431000,
        59606001,
        41631000,
        22504000,
        41736000,
        41324000,
        20743000,
        16256000,
        16255000,
        16029009,
        16029008,
        16029007,
        16029006,
        16029005,
        16029004,
        16029003,
        16029002,
        98695000,
        97180004,
        97180001,
        49453001,
        19219000,
        19653000,
        81979000,
        80752003,
        80747003,
        19040000,
        19030006,
        19030002,
        19029004,
        80497001,
        80491002,
        80490003,
        19042011,
        19042009,
        81401000,
        79871004,
        67276030,
        72248011,
        72248009,
        67437000,
        67436000,
        62028000,
        22791011,
        20496004,
        49997000,
        52069000,
        16955001,
        98689000,
        98688000,
        82001000,
        49374000,
        67832009,
        82009005,
        81204002,
        67832005,
        21844000,
        20958000,
        82306000,
        81922000,
        41447000,
        49307000,
        19591002,
        22791004,
        21966001,
        81947000,
        82797000,
        13112002,
        13112001,
        22690000,
        22834000,
        22833000,
        21799000,
        21174000,
        20960000,
        17546000,
        16876000,
        60316003,
        82616000,
        82042000,
        19455003,
        19753000,
        19752000,
        19455002,
        81950000,
        81949000,
        81948000,
        81978000,
        81737000,
        19041002,
        19029006,
        19037000,
        80490002,
        81400000,
        76742000,
        79871002,
        76680000,
        76387000,
        67578000,
        59382000,
        49879000,
        19566000,
        20392000,
        67568033,
        22791010,
        52068000,
        16485000,
        60316002,
        60316001,
        97193000,
        7633001,
        49726006,
        49726001,
        49726011,
        19217000,
        19806000,
        19805001,
        82131001,
        19201028,
        81516000,
        80491001,
        80490001,
        67568001,
        97190001,
        67568027,
        19445030,
        8455000,
        41632000,
        19445012,
        19445014,
        19445011,
        19209009,
        98935000,
        19209011,
        19445016,
        19445001,
        19445002,
        19445009,
        19445025,
        19445023,
        19445015,
        19445013,
        49753017,
        16377000,
        19209001,
        19445008,
        19445007,
        19445005,
        19445004,
        19445003,
        19445006,
        19445024,
        19445010,
        49753006,
        49753003,
        81775000,
        19571005,
        72345000,
        41364000,
        41567000,
        41316003,
        41316005,
        16313000,
        98037000,
        49753010,
        81583000,
        82340004,
        19046031,
        72329000,
        19208004,
        19208003,
        19208002,
        19807001,
        19801001,
        19800001,
        19046032,
        81738000,
        81729000,
        81736000,
        81732000,
        81734000,
        81731000,
        81728000,
        19568000,
        19567000,
        19227000,
        80228000,
        81375001,
        81141006,
        81141005,
        81141004,
        67830003,
        67830007,
        72243003,
        72243001,
        79644001,
        67638004,
        67638003,
        67276032,
        72909000,
        72908000,
        76388000,
        76386000,
        67580002,
        67580001,
        67580005,
        67569009,
        67570008,
        67570007,
        67570010,
        67570005,
        67570004,
        67570003,
        67570001,
        67712004,
        22791002,
        81735000,
        81730000,
        41564007,
        41564004,
        49985000,
        49984000,
        82052000,
        81719000,
        19571006,
        22791009,
        41452000,
        49724012,
        8097000,
        8096000,
        82196001,
        82196003,
        49878000,
        49877000,
        81944000,
        41630001,
        16369000,
        59608000,
        58316000,
        58315000,
        41629001,
        21267000,
        22836000,
        16368000,
        82587003,
        82587001,
        19454001,
        82604002,
        82604001,
        19454002,
        82131004,
        82131005,
        82131003,
        82131002,
        19590000,
        19571001,
        19571002,
        19030001,
        19029002,
        19029001,
        19035000,
        79876002,
        72910000,
        72529001,
        67799005,
        67799004,
        41564003,
        20652000,
        41564002,
        8452000,
        49368000,
        19624003,
        81159004,
        81159003,
        98613003,
        98611002,
        82054001,
        82054037,
        49274000,
        81159002,
        49995000,
        41318000,
        41562003,
        98612000,
        98611011,
        98611004,
        98611003,
        98611001,
        98611008,
        98611007,
        98611006,
        98611005,
        19214001,
        49369000,
        19214004,
        19214003,
        19214002,
        81159001,
        58924006,
        52461000,
        41630002,
        41562002,
        41564001,
        22847000,
        15333002,
        16042001,
        82131007,
        82131006,
        8457000,
        16278013,
        16278012,
        19571004,
        82054026,
        82015000,
        82161000,
        82159000,
        81656000,
        82503000,
        49142000,
        19962000,
        49134000,
        49131000,
        81851000,
        19042010,
        19042008,
        19042007,
        19042005,
        19042004,
        19042003,
        19042002,
        19042001,
        81375005,
        80450008,
        67830002,
        67830001,
        67830006,
        67830005,
        79876001,
        79644005,
        72248010,
        72248007,
        72248005,
        72248002,
        72248001,
        72248004,
        72825000,
        67581002,
        67435000,
        16278015,
        16278014,
        82162000,
        82158000,
        19737003,
        58932000,
        58933000,
        58785000,
        58607000,
        58369000,
        58368000,
        20496001,
        16450000,
        82156000,
        82157000,
        81721000,
        22791008,
        20496005,
        20496003,
        82016000,
        82160000,
        19216000,
        20496002,
        20959000,
        16451000,
        19218000,
        80450011,
        80450010,
        49297012,
        19934006,
        19934004,
        19934003,
        19934002,
        19215000,
        19737004,
        19934010,
        19934009,
        19934008,
        19934007,
        19934001,
        80450003,
        80450002,
        80450001,
        80450009,
        80450007,
        80450006,
        80450005,
        80450004,
        72981000,
        67830009,
        72982000,
        80609000,
        19776000,
        49127000,
        72804010,
        72804005,
        72804003,
        72804002,
        72804001,
        72802006,
        72802005,
        72802004,
        72802002,
        72802001,
        67579000,
        58924004,
        58924003,
        52067000,
        20957000,
        82615000,
        58924002,
        58924001,
        41428000,
        17608000,
        49724011,
        49724001,
        49724010,
        49724009,
        49724008,
        81399002,
        52460000,
        41429000,
        97180007,
        21797000,
        52390000,
        41562004,
        17644002,
        62016000,
        19981000,
        58924005,
        52462000,
        41562005,
        21955002,
        20664000,
        15273000,
        816001,
        49724002,
        49724007,
        49724006,
        49724005,
        49724004,
        49724003,
        19457001,
        19446001,
        81981000,
        81975000,
        81665000,
        67830004,
        80730002,
        72757000,
        67577000,
        67576000,
        67637000,
        20496007,
        21955001,
        17607000,
        41498000,
        41496000,
        19421000,
        41497000,
        98280001,
        20391002,
        49609000,
        19933004,
        59538002,
        20651000,
        19052001,
        19737006,
        19737007,
        19737002,
        81720000,
        59538003,
        22791007,
        49617000,
        81946000,
        49615000,
        82719000,
        82720004,
        82720003,
        82720002,
        82720001,
        81945000,
        19052002,
        19455001,
        19737008,
        19030005,
        19029010,
        19029003,
        72518003,
        83363000,
        41495000,
        59538001,
        41365000,
        20496006,
        49876000,
        49817000,
        49814000,
        19046016,
        21845000,
        22718000,
        22717000,
        16825000,
        58071000,
        41427000,
        41564005,
        21785000,
        22719000,
        22835000,
        22720000,
        22716000,
        21922000,
        16824000,
        16773001,
        16954000,
        64003004,
        97314000,
        64003002,
        49989000,
        82051005,
        82340001,
        72325000,
        49752000,
        19224000,
        19223000,
        81951000,
        81980000,
        81733000,
        67830018,
        67830017,
        67830010,
        81203004,
        79353000,
        67276017,
        67638021,
        79058000,
        72524001,
        41564006,
        49612000,
        49305001,
        19484000,
        80002000,
        79994000,
        21842000,
        21968001,
        82195002,
        82195001,
        19624002,
        67734004,
        67734001,
        41737000,
        22791006,
        41316010,
        41316002,
        41316007,
        19446021,
        79356000,
        79876004,
        79906000,
        72756000,
        82196002,
        49614000,
        16131000,
        49606000,
        49305004,
        49834000,
        21788000,
        20740000,
        58664000,
        58922000,
        41494000,
        41316004,
        41316008,
        41316009,
        16535000,
        91183000,
        91182000,
        91163000,
        20390000,
        82176000,
        19802001,
        81399001,
        22860000,
        16278011,
        16278010,
        22791005,
        22503000,
        22397002,
        16278003,
        82348003,
        58314000,
        22397001,
        16726000,
        16278009,
        16278008,
        16278007,
        16278006,
        16278005,
        16278004,
        16278002,
        16278001,
        81519000,
        19737005,
        19737009,
        19737001,
        80129002,
        72822000,
        72766000,
        67636000,
        81204001,
        62022000,
        49608000,
        72321000,
        19446020,
        49136000,
        49370000,
        17644001,
        98279002,
        49611000,
        49135000,
        58313000,
        58312000,
        58254000,
        58253000,
        21784000,
        19800002,
        8467001,
        61475001,
        20391001,
        19808003,
        19808002,
        82195003,
        19650003,
        19650001,
        19650002,
        82369000,
        19650006,
        19651002,
        19808001,
        19651005,
        19651004,
        19651006,
        19651003,
        19650005,
        19650004,
        80451003,
        80451002,
        80451001,
        67830008,
        81203003,
        67799006,
        67799003,
        67799002,
        15566003,
        15566004,
        15566002,
        16234007,
        16234006,
        16234005,
        16234004,
        16234002,
        16234001,
        41431000,
        98610000,
        49613000,
        58666000,
        41363000,
        17882006,
        82587002,
        72348000,
        72324000,
        72322000,
        72320000,
        19051000,
        19446019,
        19654009,
        19654008,
        19654007,
        19654010,
        19654006,
        19654004,
        19654003,
        19654002,
        19654001,
        80451004,
        80451006,
        80451005,
        72753000,
        72522000,
        72523000,
        41628003,
        16234003,
        49605000,
        19651001,
        98937000,
        49753016,
        82357012,
        82357009,
        82357007,
        19050001,
        19050002,
        19046013,
        19046012,
        49753007,
        79056002,
        67276013,
        67276012,
        22791003,
        80625019,
        58616000,
        83601000,
        83602000,
        81417000,
        81416000,
        58665000,
        59189000,
        59188000,
        59187000,
        58116000,
        58115000,
        58114000,
        58119000,
        58118000,
        58117000,
        58122000,
        58121000,
        58120000,
        41626001,
        41626002,
        41627001,
        41627002,
        41628004,
        41628002,
        41628001,
        52088000,
        21614000,
        21594000,
        41740000,
        41316011,
        41316001,
        67830019,
        62019000,
        63701000,
        68854003,
        81191005,
        97240000,
        49991000,
        49992000,
        82051004,
        49698000,
        19629001,
        19624001,
        19052003,
        49975000,
        19446018,
        80625005,
        81520000,
        19569000,
        19147000,
        79876003,
        81033000,
        81013000,
        72818000,
        72767000,
        49983000,
        41316012,
        19716004,
        82054046,
        98697000,
        16366000,
        8456000,
        16059000,
        69892000,
        823000,
        822000,
        16139000,
        97004000,
        19446014,
        81031000,
        82532000,
        19716002,
        80625013,
        19716001,
        81977000,
        67638017,
        67638014,
        80625010,
        72765000,
        72760000,
        72759000,
        19716003,
        19049000,
        67307000,
        49753023,
        49753024,
        20393002,
        49753014,
        49753013,
        49753012,
        49753011,
        19046033,
        19046011,
        19046035,
        19046008,
        49753005,
        49753004,
        67276023,
        67276026,
        67276024,
        67276011,
        67276009,
        22502000,
        49753015,
        80585000,
        17882005,
        80612000,
        814001,
        49610000,
        59535002,
        58668000,
        81140000,
        17702001,
        41645000,
        17586000,
        16214001,
        8668000,
        8667000,
        19446017,
        19446016,
        49607000,
        19046001,
        49377004,
        49377003,
        49377002,
        49377001,
        19046021,
        19046028,
        81976000,
        67638016,
        67638015,
        72249009,
        72249008,
        72249006,
        72819000,
        67276028,
        67276021,
        72764000,
        82366000,
        49753008,
        82367000,
        80997000,
        49753002,
        82363001,
        82362001,
        82360006,
        82358024,
        82358022,
        52396000,
        82360001,
        82358012,
        82358008,
        82358007,
        82358006,
        82358002,
        82358001,
        82357011,
        82357010,
        82357008,
        82357006,
        82357005,
        82357004,
        82357003,
        82357002,
        82357001,
        82356001,
        82355001,
        82354009,
        82354008,
        82354007,
        82354006,
        82354005,
        82354004,
        82354003,
        82354002,
        82353003,
        79811000,
        82353002,
        82353001,
        82352002,
        82352001,
        82351004,
        82351003,
        82351002,
        82351001,
        82349005,
        82349004,
        82349003,
        82349002,
        82349001,
        82348006,
        82348005,
        82348004,
        82348002,
        82348001,
        82347017,
        82347016,
        82347015,
        82347014,
        82347013,
        82347012,
        82347011,
        82347010,
        82347009,
        82347008,
        82347007,
        82347006,
        82347005,
        82347004,
        82347003,
        82347002,
        82347001,
        82361001,
        82360005,
        82360004,
        82360003,
        82360002,
        82358032,
        82358031,
        82358030,
        82358029,
        82358028,
        82358027,
        82358026,
        82358025,
        82359002,
        82359001,
        82358023,
        82358021,
        82358020,
        82358019,
        82358018,
        82358017,
        82358016,
        82358015,
        82358014,
        82358013,
        82358011,
        82358010,
        82358009,
        82358005,
        82358004,
        82358003,
        82356002,
        82354011,
        82354010,
        82354001,
        82350001,
        81203002,
        22791001,
        16214003,
        16245000,
        59536001,
        58070000,
        81204008,
        1166,
        1165,
        1164,
        1162,
        15351001,
        17882009,
        17882004,
        16266001,
        16058000,
        19208010,
        19208009,
        19208008,
        19208007,
        19208006,
        98514006,
        98514005,
        98514004,
        98514003,
        98514002,
        98514001,
        82051003,
        82051002,
        82051001,
        19446013,
        49809002,
        49809001,
        19446015,
        81035004,
        81035003,
        81035001,
        80996000,
        80729002,
        80729001,
        72758000,
        59535001,
        59537002,
        59537001,
        17882003,
        58667000,
        21378002,
        8617011,
        8617010,
        8617009,
        8617008,
        8617007,
        8617006,
        8617002,
        19446010,
        19446012,
        19446009,
        81203001,
        67638010,
        72249005,
        8617004,
        8617001,
        19717001,
        17882008,
        8617005,
        8617003,
        19446011,
        41537000,
        49569002,
        49569073,
        49569011,
        49569095,
        49569026,
        49569060,
        49569093,
        49569092,
        49569053,
        49569094,
        49569022,
        49569025,
        49569096,
        49569044,
        49569058,
        16508001,
        82043000,
        19046014,
        67276015,
        67276014,
        67638011,
        22924000,
        49753020,
        49753022,
        49753019,
        20393001,
        79056003,
        19046010,
        19046003,
        19053004,
        67277000,
        67276027,
        67276006,
        67276010,
        67276004,
        67276003,
        49753018,
        49753021,
        17882007,
        17882002,
        82044000,
        19046020,
        19046006,
        49753001,
        19053005,
        19053002,
        19053001,
        67276019,
        67276018,
        67276029,
        67276022,
        67276025,
        67276001,
        67276020,
        19053003,
        19446008,
        67638008,
        59774001,
        8029002,
        82813000,
        8030002,
        59962000,
        52066000,
        17882001,
        16725000,
        16724000,
        82814000,
        49725002,
        49725001,
        49725004,
        49725003,
        19446005,
        80923001,
        19042006,
        80730001,
        67638005,
        59775001,
        41673002,
        58225000,
        19446006,
        19446007,
        67638006,
        58673000,
        59328000,
        41673001,
        67592000,
        58676000,
        21216006,
        15156000,
        80923002,
        21176000,
        59774002,
        8030001,
        19054000,
        8029001,
        58675000,
        82038000,
        19055000,
        82364002,
        82364001,
        20515000,
        80922004,
        80922003,
        80922002,
        80922001,
        80491004,
        67591000,
        19587000,
        52369000,
        82039000,
        49282000,
        49569038,
        49569007,
        49569046,
        49569052,
        49569015,
        49569003,
        49569019,
        49569041,
        49569040,
        49569059,
        80491003,
        52370000,
        58659000,
        19586000,
        67569007,
        16778000,
        58669000,
        20955000,
        20402000,
        49281002,
        49281001,
        19044000,
        72248015,
        72248014,
        72248012,
        19043000,
        72248013,
        16780000,
        21181000,
        16630000,
        58817000,
        1163,
        41549000,
        16781000,
        41743000,
        21378001,
        22846000,
        58255000,
        20863003,
        58320000,
        58378000,
        58379000,
        1167,
        22928000,
        15344001,
        15352000,
        20853002,
        19801002,
        8646004,
        8646003,
        8646002,
        8646001,
        8625000,
        98887002,
        8026000,
        8025000,
        8001000,
        70127019,
        70127049,
        98889000,
        98888000,
        98887001,
        98886000,
        98873000,
        98872000,
        98871000,
        98870000,
        98865000,
        98856000,
        98855000,
        98860000,
        98859000,
        98858000,
        98857000
      ]
      return codes.find(el => this.code.includes(el))
    },
    cityName () {
      if (this.selectedUserLocation) {
        return this.isUkLanguage ? this.selectedUserLocation.name_uk : this.selectedUserLocation.name_ru
      } else {
        return this.$t('city')
      }
    },
    titleForExpressDelivery () {
      return dateTimeHelper.isAvailableTodayExpressDelivery() ? this.$t('delivery.company.quick.courier.before') : this.$t('delivery.company.quick.courier.after')
    }
  },
  methods: {
    ...mapActions(['FETCH_PRODUCT_AVAILABILITY_IN_SHOPS']),
    toggleListHidden (list) {
      this.hiddenLists[list] = !this.hiddenLists[list]
    },
    checkAvailability () {
      if (this.isLoadingAvailability) return

      if (this.productId && this.selectedUserLocation && this.selectedUserLocation.city_id) {
        this.isLoadingAvailability = true

        this.FETCH_PRODUCT_AVAILABILITY_IN_SHOPS({
          productId: this.productId,
          cityId: this.selectedUserLocation.city_id
        })
          .then(res => {
            if (res.data) {
              this.$modal.show('map-modal', {
                spots: this.formatDeliverySpotsInfo(res.data.stores, 'availability'),
                mailName: 'pickup',
                preSelectedSpot: this.managerStoreUid
              })
            }
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => (this.isLoadingAvailability = false))
      }
    }
  }
}
</script>

<style scoped lang="sass">
.details
  &__subtitle
    font-size: 14px
    line-height: 1.6
    margin-top: 5px
    &.secondary
      color: #909090
  &__title-wrap
    display: flex
    flex-direction: column
  &__header-wrap
    display: flex
    align-items: flex-start
    svg
      width: 24px
      flex-shrink: 0
      margin-right: 20px

.details__wrap
  position: relative
  .details__header
    padding: 20px 0 0
  &--with-border
    border-bottom: 1px solid $nd-border-color
    border-top: none
    .details__header
      padding: 20px 0
      .details__title
        font-size: 18px
  &:first-child
    +mmin($tablet)
      border-top: none

.details__header
  display: flex
  justify-content: space-between
  align-items: center
  padding: 20px 0

  +mmax(768)
    cursor: pointer

.details__title
  position: relative
  font-size: 16px
  font-weight: 500
  margin: 0
  padding: 0

.details__select-city
  position: relative
  color: $nd-link-color
  border-bottom: 1px solid $nd-link-color
  cursor: pointer

  &:after
    position: absolute
    right: -15px
    top: 50%
    transform: translateY(-50%)
    content: ''
    display: block
    width: 11px
    height: 6px
    background: url('/img/svgo/link-arrow.svg')

.details__list
  +list-unstyled
  height: 100%
  max-height: 400px
  transition: ease-in-out .4s
  margin: 0 0 20px
  &-mobile-item
    border-top: 1px solid #E7E7E7
    //border-bottom: 1px solid #E7E7E7
    border-right: 1px solid #E7E7E7
    display: flex
    flex-direction: column
    align-items: center
    padding: 15px 5px
    flex-grow: 1
    &-price
      font-size: 14px
      text-align: center
      line-height: 1.2
      font-weight: 500
      &--free
        color: #359D3F
    &-title
      font-size: 14px
      text-align: center
      line-height: 1.2
      margin-bottom: 5px
    svg
      margin-bottom: 5px
    &:last-child
      border-right: none
  &--mobile
    display: none
    //display: flex
    //align-items: stretch
    //padding-top: 15px
    //+mmin($tablet)
    //  display: none
  &--delivery
    +mmax($tablet)
      padding-top: 20px

  &--hidden
    +mmax(768)
      margin: 0
      max-height: 0

.payment__list
  +list-unstyled

.details__list--services
  .details__list-item-text
    color: $placeholder-color

.details__list-item
  font-size: 14px

  &:not(:last-child)
    margin-bottom: 15px

  &:before
    content: '•'
    padding-right: 10px

.payment
  display: flex

.payment__list
  display: flex
  flex-flow: row wrap

.payment__list-item
  display: block

  &:not(:last-child)
    margin: 0 10px 0 0

.details__list--delivery
  .details__list-item
    display: flex

  .details__check-availability-btn
    max-width: max-content
    font-size: 14px
    padding: 0
    background: none
    border: none
    border-bottom: 1px solid #3e77aa
    color: $nd-link-color
    margin-top: 10px

    &:hover
      border-color: transparent

    +mmin($small)
      margin-top: 0

  .details__delivery-wrap
    width: 100%
    display: flex
    flex-flow: column

    +mmin($small)
      justify-content: space-between
      flex-flow: row nowrap

  .details__delivery-info
    display: flex
    flex-flow: column

    +mmin($small)
      align-items: center
      flex-flow: row wrap

  .delivery-info__date
    display: none
    color: $placeholder-color

  .details-info__text
    margin-right: 20px

  .delivery-info__price
    margin-top: 10px
    font-weight: 500

    +mmin($small)
      margin-top: 0

  .delivery-info__price--free
    color: #359D3F

  .details__list-item--dm
    &:before
      content: url(/img/svgo/product-page/dm-big.svg)
      padding-right: 20px

  .details__list-item--np
    &:before
      content: url(/img/svgo/product-page/np-big.svg)
      padding-right: 20px

  .details__list-item--up
    &:before
      content: url(/img/svgo/product-page/upost-big.svg)
      padding-right: 20px

  .details__list-item--quick
    &:before
      content: url(/img/svgo/product-page/quick_list_icon.svg)
      padding-right: 20px

.details__info-btn
  display: block
  position: absolute
  right: 0
  top: 20px

  +mmin($tablet)
    display: block

.details__toggle-btn
  width: 12px
  height: 6px
  display: none
  border: 0
  background-color: transparent
  background-image: url('/img/svgo/product-page/details-arrow.svg')
  background-position: center
  background-repeat: no-repeat
  transition: ease-in-out .4s

  +mmax(768)
    display: none

  &--rotate
    transform: rotate(180deg)

.details__check-availability
  margin: 0 0 30px 0
  +mmax($tablet)
    margin: 0 -15px

.check-availability
  background: #F8F8F8
  border-radius: 3px
  padding: 6px 25px
  display: flex
  justify-content: space-between
  align-items: center
  flex-wrap: wrap

  +mmax(601)
    padding: 15px

  &__info
    position: relative
    margin: 8px 0
    padding-left: 65px
    +mmin($tablet)
      padding-left: 50px

    &:before
      content: ''
      background-image: url('/img/svgo/product-page/product-details-title.svg')
      background-position: center
      background-repeat: no-repeat
      background-size: cover
      position: absolute
      left: 0
      top: -5px
      width: 50px
      height: 50px
      +mmin($tablet)
        width: 30px
        height: 35px

  &__text
    font-size: 14px
    color: #333
    font-weight: 500
    &.title-text
      font-size: 16px
      font-weight: 500
    &+&
      margin-top: 4px
    &--success
      color: #359D3F
    &--time
      color: #909090
      font-size: 14px
      line-height: 1.25
      padding-right: 8px
      margin-right: 8px
      border-right: 1px solid #CCCCCC
      font-weight: 500

  &__btn
    margin: 8px 0
    margin-left: 50px
    font-size: 14px
    padding: 10px 30px 12px
    +mmax(601)
      margin-left: 0
      width: 100%
      padding: 14px 30px 16px
      font-size: 16px
</style>
